import hash from 'src/router/hash.js';

// 定义所需的mutations
const mutations = {
    // 曾加页签
    AddTab (state, target) {
        let addFlag = true, // tab是否被选中
            newTitle = target.name,
            newTabName = state.tabIndex + '';

        // homeTabs为打开的tabs数组
        var len = state.homeTabs.length;

        // 处理已经打开的tab
        for (var i = 0; i < len; i++) {
            if (state.homeTabs[i].title === newTitle) {
                state.homeCurrentTab = state.homeTabs[i].name;
                state.currentTab = state.homeTabs[i];

                // 已经打开的tab，可以在这里重置config值
                state.homeTabs[i].timestamp = new Date().getTime();
                addFlag = false;
                break;
            }
        }

        if (addFlag) {
            state.homeTabs.push({
                id: target.id,
                path: target.path,
                title: newTitle,
                name: newTabName,
                component: target.comp,
                config: target.config,
                timestamp: new Date().getTime()
            });

            state.currentTab = {
                id: target.id,
                path: target.path,
                title: newTitle,
                name: newTabName,
                component: target.comp,
                config: target.config,
                timestamp: new Date().getTime(),
                unHash: !!target.unHash,
                channel: target.channel || ''
            };

            state.homeCurrentTab = newTabName;
            ++state.tabIndex;
        }

        hash.change(target.path, false);
    },
    // 删除页签
    RemoveTab (state, targetName) {
        let tabs = state.homeTabs;
        let activeName = state.homeCurrentTab;

        // 用来判断羞羞页面是关闭标签时才显示
        if (state) {
            state.defaultStatus = true;
        } else {
            state.defaultStatus = false;
        }
        tabs.forEach((tab, index) => {
            // 删除的是当前打开的
            if (activeName === targetName) {
                if (tab.name === targetName) {
                    let nextTab = tabs[index + 1] || tabs[index - 1];

                    if (nextTab) {
                        activeName = nextTab.name;
                        state.currentTab = nextTab;
                        hash.change(nextTab.path, nextTab.unHash);
                    }
                }
            }
        });
        state.homeCurrentTab = activeName;
        state.homeTabs = tabs.filter(tab => tab.name !== targetName);
    },
    // 点击页签
    ClickTab (state, target) {
        let tabs = state.homeTabs;
        let activeName = state.homeCurrentTab;

        tabs.forEach((tab, index) => {
            if (tab.name === target.name) {

                activeName = tab.name;

                state.currentTab = tab;

                // 更新该tab的时间戳
                tab.timestamp = new Date().getTime();

                hash.change(tab.path, tab.unHash);
            }
        });
        state.homeCurrentTab = activeName;
    },

    // 添加权限
    SetPermission (state, target) {
        state.permission = target;
    },

    SetOrderManageData (state, target) {
        state.orderManageData = target;
    }

};

export {
    mutations
};


// WEBPACK FOOTER //
// ./src/store/mutations.js